import { parseIso } from "@/lib/dates";

export type Opening = { hours?: { weekday: number; closed: boolean; open_time: string | null; close_time: string | null }[]; closures?: { from: string; to: string; reason: string | null; open_time: string | null; close_time: string | null }[] };

/** True when the store is closed on that ISO date: weekly hours say closed (or none set), or a closure without special hours covers it. */
export function closedOn(store: Opening, iso: string): boolean {
  const d = parseIso(iso);
  if (!d) return false;
  const special = (store.closures ?? []).find((c) => c.from <= iso && iso <= c.to);
  if (special) return !(special.open_time && special.close_time);
  const wd = (d.getDay() + 6) % 7;
  const h = store.hours?.find((x) => x.weekday === wd);
  return !h || h.closed || !h.open_time || !h.close_time;
}

/** The closure note for a date, when any. */
export function closureNote(store: Opening, iso: string): string | null {
  const c = (store.closures ?? []).find((x) => x.from <= iso && iso <= x.to);
  return c?.reason ?? null;
}
